<template>
  <div class="about">
    <h1>Logout</h1>
  </div>
</template>
<script>
export default {
	name: 'Logout',
	components: {
	},
	mounted(){
		this.logout();
	},
	data() {
		return{
			email: '',
			password: '',
			error_msg: '',
		};
	},
	methods: {
		logout(){
			this.$session.destroy()
			this.$router.push('/')
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.mt-xl{
	margin-top: 100px;
}
.btn-black{
	background-color: #000;
	color: #FFF;
	padding: 6px 25px;
}
</style>